<template>
  <BaseIconButton
    v-tooltip.bottom="$t('dialog.download.tooltip')"
    icon="download"
    size="M"
    width="narrow"
    color="outlined"
    @click="openExportDialog"
    :loading="isDownloading"
  />
  <DialogExportDialog
    :is-open="isExportOpen"
    :dialog-phase="dialogPhase"
    :is-downloading="isDownloading"
    @close="closeExportDialog"
    @submit="onExport"
  />
</template>
<script lang="ts" setup>
  import BaseIconButton from '@/core/components/base/button/icon-button/BaseIconButton.vue'
  import { useFileDownload } from '@/core/composables/use-download-file'
  import { useDialog } from '@/core/components/base/dialog/use-dialog'
  import DialogExportDialog, { type CommentScope } from './DialogExportDialog.vue'
  import type { DialogPhase } from '@/core/models/dialog/dialog'

  interface Props {
    dialogId: string
    dialogPhase: DialogPhase
  }

  const props = defineProps<Props>()

  const { downloadFile, isDownloading } = useFileDownload(`dialog/${props.dialogId}/pdf`)
  const {
    isOpen: isExportOpen,
    openDialog: openExportDialog,
    closeDialog: closeExportDialog,
  } = useDialog()

  const onExport = async (commentScope: CommentScope) => {
    const success = await downloadFile({ query: { commentScope } })
    if (success) {
      closeExportDialog()
    }
  }
</script>
